import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { ContentLayout, SelectedPipe, Label } from './styles';

const TabSelector = ({ tab, sectionName, isSelected, setSelectTab, setQueryTab = () => {} }) => {
  const { t } = useTranslation();

  const toTop = () => window.scrollTo(0, 0);

  return (
    <ContentLayout
      isSelected={isSelected}
      onClick={() => {
        if (!isSelected) {
          setSelectTab(tab);
          setQueryTab(tab);
          toTop();
        }
      }}
    >
      {isSelected && <SelectedPipe data-panel={`${sectionName}-tabSelected-${tab}`} />}
      <Label data-panel={`${sectionName}-tabLabel-${tab}`}>{t(`panel.${sectionName}.leftBar.title.${tab}`)}</Label>
    </ContentLayout>
  );
};

TabSelector.propTypes = {
  tab: PropTypes.string.isRequired,
  sectionName: PropTypes.string.isRequired,
  isSelected: PropTypes.bool.isRequired,
  setSelectTab: PropTypes.func.isRequired
};

export default TabSelector;
